export default function useBackblazeService() {
  async function uploadFile(
    file: File,
    prefix: string,
  ): Promise<{ fileUrl: string; fileId: string }> {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("prefix", prefix);

    const response = await $fetch("/api/storage/upload", {
      method: HttpMethod.POST,
      body: formData,
    });

    // add a timestamp on the end of the url so that the browser doesn't get the
    // cached version of the image when user updates an existing one (because URL is the same)
    const uploadedFileUrl =
      response.fileUrl + "?timestamp=" + new Date().getTime();

    return {
      fileUrl: uploadedFileUrl,
      fileId: response.fileId,
    };
  }

  async function removeFile(fileUrl: string, fileId?: string): Promise<void> {
    await $fetch("/api/storage", {
      method: HttpMethod.DELETE,
      query: {
        file_url: fileUrl,
        file_id: fileId,
      },
    });
  }

  async function getPrivateFileDownloadUrl(fileId: string): Promise<string> {
    try {
      const response = await $fetch("/api/storage/download", {
        method: HttpMethod.GET,
        query: {
          fileId: fileId,
        },
      });

      return response.url;
    } catch (error) {
      usePosthog().logError(
        error,
        "useBackblazeService:getPrivateFileDownloadUrl",
        `Error donwloading private file from Backblaze: ${fileId}`,
      );

      throw error;
    }
  }

  return {
    uploadFile,
    removeFile,
    getPrivateFileDownloadUrl,
  };
}
